import { TextDomTag } from 'client/widget-components/basicComponents/Text';
import BaseCharCounter from 'client/widget-components/components/TextField/components/BaseCharCounter';
import { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';
import { CUSTOMIZATIONS_DATA_GRABS } from '../../constants';
import BaseProductCustomizationLabel from '../BaseProductCustomizationLabel';
import PaidAddonLabel from '../PaidAddonLabel';

interface TextFieldCustomizationLabelProps {
    label: string;
    valueLength: number;
    maxLength: number;
    required?: boolean;
    price?: number;
    displayedPrice?: string;
    styles: {
        inputLabel?: ResponsiveStylesProp;
        inputCharacterCounter?: ResponsiveStylesProp;
        paidAddonText?: ResponsiveStylesProp;
    };
}

const TextFieldCustomizationLabel = ({
    styles,
    label,
    required,
    price,
    displayedPrice,
    valueLength,
    maxLength,
}: TextFieldCustomizationLabelProps) => (
    <BaseProductCustomizationLabel
        label={
            <PaidAddonLabel
                label={label}
                price={price}
                displayedPrice={displayedPrice}
                styles={styles.paidAddonText}
            />
        }
        required={required}
        styles={styles.inputLabel}
        dataGrab={CUSTOMIZATIONS_DATA_GRABS.labelDataGrab}
        dataAuto='product-customizations-text-field-label'
    >
        <BaseCharCounter
            valueLength={valueLength}
            maxLength={maxLength}
            tag={TextDomTag.span}
            styles={styles.inputCharacterCounter}
            dataGrab={CUSTOMIZATIONS_DATA_GRABS.counterDataGrab}
            dataAuto='product-customizations-text-field-counter'
        />
    </BaseProductCustomizationLabel>
);

export default TextFieldCustomizationLabel;
